import { useQuery } from "react-query";
import { TokenizedCardService } from "./tokenized-card.service";

// GET List
const useGetTokenizedCardList = (
  user_id: string,
  page: number,
  option?: Object
) => {
  return useQuery(
    ["listTokenizedCard", user_id, page, option],
    async () => {
      const { data } = await TokenizedCardService.getListByUser({
        user_id,
        page,
        ...option,
      });
      return data;
    },
    { 
      keepPreviousData: true,
      enabled: !!user_id 
    }
  );
};

export { useGetTokenizedCardList };
